import React, { useEffect } from 'react';
import styled from 'styled-components';
import ReactModal from 'react-modal';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { IClose } from 'planoplan-ui-kit/core/icons/i-close';
import { zIndex, Points } from '@styles';
import { MODAL_ROOT, MODAL_TIMEOUT } from '@constants/params';

const customStyles = {
  content: {
    top: '0',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    border: 'none',
    background: 'transparent',
    padding: '0',
    overflow: 'initial',
  },
  overlay: {
    backgroundColor: 'none',
    zIndex: zIndex('modal'),
  },
};

export const Modal = ({
  isOpen = false,
  onClose = () => {},
  onAfterOpen = () => {},
  onAfterClose = () => {},
  onOpenByHash = () => {},
  label = '',
  overlayStyle = {},
  shouldCloseOnOverlayClick = true,
  children,
}) => {
  const styles = {
    content: customStyles.content,
    overlay: {
      ...customStyles.overlay,
      ...overlayStyle,
    },
  };

  const onClickLayer = () => {
    if (shouldCloseOnOverlayClick) {
      onClose();
    }
  };

  const stopPropagation = (event) => {
    event.stopPropagation();
  };

  const renderContent = (props, children) => (
    <div {...props} onClick={onClickLayer} onMouseDown={onClickLayer} onTouchEnd={onClickLayer}>
      {children}
    </div>
  );

  useEffect(() => {
    ReactModal.setAppElement(MODAL_ROOT);

    const hashId = window.location.hash.substring(1);

    if (hashId) {
      onOpenByHash(hashId);
    }
  }, []);

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      onAfterOpen={onAfterOpen}
      onAfterClose={onAfterClose}
      style={styles}
      contentLabel={label}
      contentElement={renderContent}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      closeTimeoutMS={MODAL_TIMEOUT}>
      <Content onClick={stopPropagation} onMouseDown={stopPropagation} onTouchEnd={stopPropagation}>
        <Close onClick={onClose}>
          <IClose />
        </Close>
        {children}
      </Content>
    </ReactModal>
  );
};

const Content = styled.div`
  background-color: ${Colors.white};
  border-radius: 10px;
  position: relative;
  padding: 30px 18px;
  max-width: 1440px;
  min-width: 320px;
  margin-top: 20px;
  margin-bottom: 20px;
  will-change: transform, opacity;

  @media ${Points.tablet_portrait} {
    padding: 38px;
  }
`;

const Close = styled.button`
  ${Mixins.resetButton()};
  position: absolute;
  top: 9px;
  right: 9px;

  @media ${Points.tablet_portrait} {
    top: 0;
    right: -60px;
  }

  svg {
    ${Mixins.transition('transform')};
    width: 14px;
    height: 14px;
    fill: ${Colors.light_gray};

    @media ${Points.tablet_portrait} {
      width: 38px;
      height: 38px;
      fill: ${Colors.white};
    }
  }

  &:hover {
    svg {
      transform: scale(0.9);
    }
  }
`;
